import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './Breadcrumbs.scss';

interface IBreadcrumbsProps {
    crumbs: Array<{
        label: string,
        url: string,
        // A key must be provided so that react doesn't replace the links each render.
        // This solves this scenario: a user click a link as they click out of an input with an onBlur handler,
        // which causes a rerender, which causes react to swap the link's element right out from under the mouse,
        // which causes it to ignore the click. We'll prevent this by using keys, defaulting to the url.
        key?: number | number;
    }>
    dataCy?: string;
}

let crumbKey = 1;

export const Breadcrumbs: FunctionComponent<IBreadcrumbsProps> = function(props) {
    const { t, i18n } = useTranslation();

    // From: https://www.w3.org/TR/wai-aria-practices/examples/breadcrumb/index.html
    return (
        <nav aria-label={t('breadcrumbs.ariaLabel')} className="breadcrumbs">
            <ol className="breadcrumbs_list">
                {props.crumbs.map(crumb => (
                    <li key={crumb.key || crumb.url} className="breadcrumb">
                        <Link to={crumb.url} className="breadcrumbs_link" data-cy={props.dataCy}>
                            <span className="breadcrumbs_seperator" aria-hidden="true">
                                <FontAwesomeIcon icon="chevron-left" />
                            </span>
                            <span className="breadcrumbs_label">
                                {crumb.label}
                            </span>
                        </Link>
                    </li>
                ))}
            </ol>
        </nav>
    );
}